import React, { Component,useEffect }   from 'react';
import { Router,Route, Switch } from 'react-router-dom';
import { createBrowserHistory } from 'history';
import { connect } from 'react-redux';
import User from './userRoutes';
import Admin from './adminRoutes';
import SalesUserRoutes from './salesUserRoute';
//import Popup from "reactjs-popup";
const adminBase = '/admin';
const salesBase= "/tp";
const user = '/';

export const history = createBrowserHistory({});

class UserRoutes extends Component {
  render() {

    //Render Router for all three users type. (Admin, User, Sales User)
    return (
      <Router history={history}>
        <div >
          <Switch>
            <Route path={adminBase} component={Admin} />
            <Route path={salesBase} component={SalesUserRoutes} />
            <Route path={user} component={User} />
          </Switch>
        </div>
      </Router>
    );
  }
}
export default connect(null, { })(UserRoutes);


// WEBPACK FOOTER //
// ./web/routes/Routes.jsx